module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-up-en.514ac436.svg";